import React, { useState } from "react";


import {
  FaBroadcastTower,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function TelecomSectorPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Network Optimization & Management",
      points: [
        "Self-Optimizing Network (SON) Agent",
        "Anomaly Detection Agent",
        "Signal Quality Monitoring Agent",
        "Capacity Planning Agent",
        "5G Beamforming Optimization Agent",
      ],
    },

    {
      title: "Customer Service & Support",
      points: [
        "AI Call Center Agent",
        "Virtual Troubleshooting Agent",
        "Complaint Resolution Agent",
        "Churn Prediction Agent",
        "Intent Recognition Agent",
      ],
    },

    {
      title: "Predictive Analytics & Business Intelligence",
      points: [
        "Usage Pattern Prediction Agent",
        "Revenue Forecasting Agent",
        "ARPU Analysis Agent",
        "Subscriber Behavior Clustering Agent",
        "Downtime Impact Analysis Agent",
      ],
    },

    {
      title: "Security & Fraud Detection",
      points: [
        "SIM Swap Fraud Detection Agent",
        "Fake Account Detection Agent",
        "Call Pattern Monitoring Agent",
        "Billing Fraud Prevention Agent",
        "DDoS Attack Detection Agent",
      ],
    },

    {
      title: "Infrastructure, Logistics & Field Services",
      points: [
        "Site Deployment Planning Agent",
        "Fiber Rollout Optimization Agent",
        "Logistics Coordination Agent",
        "Field Technician Dispatch Agent",
        "Inventory Management Agent",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .telecom-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .telecom-hero {
          background: #173b8f;
          width: 100%;
        }

        .telecom-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .telecom-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .telecom-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .telecom-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .telecom-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .telecom-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .telecom-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .telecom-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .telecom-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .telecom-card-header.active {
          background: #173b8f;
        }

        .telecom-card-header.inactive {
          background: #ffffff;
        }

        .telecom-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .telecom-card-title.active {
          color: #ffffff;
        }

        .telecom-card-title.inactive {
          color: #173b8f;
        }

        .telecom-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .telecom-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .telecom-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .telecom-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .telecom-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .telecom-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .telecom-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .telecom-hero-inner {
            padding: 32px 0px;
          }

          .telecom-title {
            font-size: 30px;
          }

          .telecom-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .telecom-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .telecom-icon-box {
            width: 40px;
            height: 40px;
          }

          .telecom-icon-box svg {
            font-size: 18px;
          }

          .telecom-title {
            font-size: 26px;
          }

          .telecom-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .telecom-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .telecom-card-header {
            padding: 12px 16px;
          }

          .telecom-card-title {
            font-size: 15px;
          }

          .telecom-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .telecom-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .telecom-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .telecom-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .telecom-icon-box svg {
            font-size: 16px;
          }

          .telecom-title {
            font-size: 21px;
          }

          .telecom-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .telecom-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .telecom-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .telecom-card-header {
            padding: 10px 14px;
          }

          .telecom-card-title {
            font-size: 14px;
          }

          .telecom-card-content {
            padding: 14px 14px;
          }

          .telecom-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .telecom-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .telecom-point-check svg {
            font-size: 9px;
          }

          .telecom-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .telecom-title {
            font-size: 18px;
          }

          .telecom-card-title {
            font-size: 13px;
          }

          .telecom-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="telecom-wrapper">
        {/* HERO SECTION */}
        <div className="telecom-hero">
          <div className="telecom-hero-inner">
            <div className="telecom-hero-top">
              <div className="telecom-icon-box">
                <FaBroadcastTower />
              </div>

              <h1 className="telecom-title">The Telecom Sector</h1>
            </div>

            <p className="telecom-description">
              Telecommunications covers internet, mobile, and network
              infrastructure. AI agents streamline network management,
              prevent service outages, enhance customer support, and
              power the rollout of technologies like 5G and IoT.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="telecom-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="telecom-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`telecom-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`telecom-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="telecom-chevron-active" />
                  ) : (
                    <FaChevronDown className="telecom-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="telecom-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="telecom-point-row">
                        <div className="telecom-point-check">
                          <FaCheck />
                        </div>

                        <p className="telecom-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default TelecomSectorPage;
